import React from 'react';
import { useNavigate } from 'react-router-dom';
import useBackupAlert from '../../hooks/useBackupAlert';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle, faDownload } from '@fortawesome/free-solid-svg-icons';
import '../../styles/Dashboard.css';
import BillSynthesis from './BillSynthesis';
import UnpaidBills from './UnpaidBills';
import CurrentQuotes from './CurrentQuotes';
import BillsToDeclare from './BillsToDeclare';

const Dashboard = () => {
  const navigate = useNavigate();
  const { shouldShowAlert, daysSinceBackup } = useBackupAlert();

  const handleGoToBackup = () => {
    navigate('/app/settings');
  };

  return (
    <div className="container">
      {shouldShowAlert && (
        <div className="notification is-danger mb-4">
          <div className="is-flex is-align-items-center">
            <div className="is-flex-grow-1">
            <span className="icon mr-2" style={{ color: 'var(--bulma-danger)' }}>
              <FontAwesomeIcon icon={faExclamationTriangle} />
            </span>
              <strong style={{ color: 'var(--bulma-danger)' }}> Sauvegarde recommandée</strong>
              <br />
              <span style={{ color: 'var(--bulma-danger)' }}>
              {daysSinceBackup === 999 
                ? "Aucune sauvegarde détectée. Il est recommandé de sauvegarder vos données."
                : `Dernière sauvegarde il y a ${daysSinceBackup} jours. `
              }
              </span>
            
            <button 
              className="button is-small is-success"
              onClick={handleGoToBackup}
            >
              <span className="icon">
                <FontAwesomeIcon icon={faDownload} />
              </span>
            </button>
          </div>
          </div>
        </div>
      )}
      
      <div className="columns is-multiline">
        <div className="column is-6">
          <BillSynthesis />
        </div>
        <div className="column is-6">
          <UnpaidBills />
        </div>
      </div>
      <div className="columns is-multiline">
        <div className="column is-6">
          <CurrentQuotes />
        </div>
        <div className="column is-6">
          <BillsToDeclare />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
